export const mutations = {
  addTemoin(state, temoin) {
    state.temoin = temoin;
  },
  setTemoin(state, temoin) {
    state.temoin = temoin;
  },
  addTemoins(state, temoin) {
    state.temoins = temoin;
  },
  addTemoinsPage(state, temoin) {
    state.temoins = temoin;
    
  },
};
